// extracted by mini-css-extract-plugin
export var csatScore = "_o1-5";
export var header = "_o1-1";
export var panelWrapper = "_o1-2";
export var postPreview = "_o1-3";
export var rightContent = "_o1-0";
export var wrappingText = "_o1-4";